import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import {
  Address,
  AddressListResponseMeta,
  ValidatedAddress,
} from '../../models/address.model'
import { BaseRepository, ListRequest, ListResponse } from '../base.repository'

@Injectable({
  providedIn: 'root',
})
export class AddressRepository extends BaseRepository<ValidatedAddress> {
  public constructor() {
    super({
      resourceName: 'addresses',
      defaultSorting: [{ property: 'content.payload.name', direction: 'asc' }],
    })
  }

  public getBranchAddresses(
    branchId: string,
    listRequest?: ListRequest<ValidatedAddress>
  ): Observable<ListResponse<ValidatedAddress, AddressListResponseMeta>> {
    return this.http.get<
      ListResponse<ValidatedAddress, AddressListResponseMeta>
    >(`${this.baseUrl}branches/${branchId}/addresses`, {
      params: this.getHttpOptionsFromListRequest(listRequest as ListRequest),
    })
  }

  public getGoldenRecord(
    listRequest?: ListRequest<ValidatedAddress>
  ): Observable<ListResponse<Address>> {
    return this.http.get<ListResponse<Address>>(
      `${this.baseUrl}branches/main/addresses`,
      {
        params: this.getHttpOptionsFromListRequest(listRequest as ListRequest),
      }
    )
  }

  public getSnapshotAddresses(
    snapshotId: string,
    listRequest?: ListRequest<ValidatedAddress>
  ): Observable<ListResponse<Address>> {
    return this.http.get<ListResponse<Address>>(
      `${this.baseUrl}snapshots/${snapshotId}/addresses`,
      {
        params: this.getHttpOptionsFromListRequest(listRequest as ListRequest),
      }
    )
  }
}
